import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=4b9d9135"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports